import "./CurrentUserAvatar.scss";
import { useSelector } from 'react-redux';
import InitialsAvatar from "../../components/InitialsAvatar/InitialsAvatar.jsx";

const CurrentUserAvatar = () => {
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    return (
        <div className='current-user-avatar'>
            <div className="user-wrapper">
                {currentUser?.usr_photo_url ? <img src={currentUser?.usr_photo_url} alt="" className='avatar' />
                    :
                    <InitialsAvatar
                        name={currentUser?.usr_full_name}
                        size={30}
                        currentTheme={currentTheme}
                    />
                }
                <div className="user-org-view">
                    <span className="user-full-name">
                        {currentUser?.usr_full_name}
                    </span>
                    <span className="user-org-name">
                        {currentUser?.usr_entity_code ? currentUser?.entity_name_xx : currentUser?.usr_org_name}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default CurrentUserAvatar